import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteDemoMutation($input: DeleteDemoInput!) {
		deleteDemo(input: $input) {
			deletedDemoId
		}
	}
`;

function getConfigs(companyId) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: companyId,
			connectionKeys: [
				{
					key: 'Company_demos',
				},
			],
			pathToConnection: ['company', 'demos'],
			deletedIDFieldName: 'deletedDemoId',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Demo Deleted');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), id: input.id}},
		configs: getConfigs(input.companyId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
